import styled from "styled-components";
import {
  MaterialCubicBezier,
  MobileWidth,
  PrimaryColor,
  SectionPadding,
  SectionPaddingMobile,
  Title,
  Wrapper,
} from "../../GlobalStyle";

export const HeroWrapper = styled.div`
  background: url(${require("../../images/hero-bg.png")}) 0 100px / contain
    no-repeat;
  display: flex;
  align-items: center;
  height: 100vh;
  overflow: hidden;

  &.active {
    .hero-left {
      ${Title}, p, .btn {
        opacity: 1;
        transform: translateX(0);
      }
    }
    .hero-right {
      img {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  ${Wrapper} {
    display: flex;
    align-items: center;
    @media screen and (max-width: ${MobileWidth}) {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 50px;
      padding-right: 0;
    }
  }

  ${Title} {
    opacity: 0;
    text-align: left;
    transform: translateX(-100%);
    transition: all 300ms ${MaterialCubicBezier};
  }

  .hero-left {
    flex: 1;

    p {
      margin-bottom: 30px;
      opacity: 0;
      text-transform: uppercase;
      transform: translateX(-100%);
      transition: all 300ms ${MaterialCubicBezier};
      transition-delay: 100ms;
    }

    .btn {
      display: inline-block;
      opacity: 0;
      text-align: center;
      transform: translateX(-100%);
      transition: all 300ms ${MaterialCubicBezier};
      transition-delay: 200ms;
      width: 190px;
    }
  }

  .hero-right {
    flex: 1;
    position: relative;
    height: 80vh;
    max-height: 500px;
    @media screen and (max-width: ${MobileWidth}) {
      margin-top: 40px;
    }

    .Tilt {
      height: 100%;
      perspective: 1000px;
      transform-style: preserve-3d;
      .Tilt-inner {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        &.coin {
          transform: translateZ(100px);
        }
      }
    }

    img {
      opacity: 0;
      transform: scale(2);
      transition: all 600ms ${MaterialCubicBezier};
      height: 100%;
      &.tilt-image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
      }
      @media screen and (max-width: ${MobileWidth}) {
        width: 75%;
        height: auto;
      }
    }
  }
`;

export const AboutWrapper = styled.div`
  background: url(${require("../../images/about-bg.png")}) center / cover
    no-repeat ${PrimaryColor};
  color: #fff;
  display: flex;
  align-items: center;
  height: 100vh;
  overflow: hidden;

  &.active {
    .about-left {
      opacity: 1;
      transform: scale(1);
    }
  }

  ${Wrapper} {
    display: flex;
    align-items: center;
    @media screen and (max-width: ${MobileWidth}) {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 50px;
    }
  }

  ${Title} {
    text-align: left;
  }

  .about-left {
    flex: 1;
    opacity: 0;
    transform: scale(2);
    transition: all 600ms ${MaterialCubicBezier};
    img {
      padding-right: 50px;
      width: 100%;
      @media screen and (max-width: ${MobileWidth}) {
        padding-bottom: 20px;
        padding-right: 0;
        width: 70%;
      }
    }

    svg {
      padding-right: 50px;
      @media screen and (max-width: ${MobileWidth}) {
        padding-bottom: 20px;
        padding-right: 0;
        width: 70%;
      }

      #box1bg {
        animation: flicking 800ms ${MaterialCubicBezier} infinite alternate;
      }
    }
  }

  .about-right {
    flex: 1;

    p {
      line-height: 26px;
    }
  }

  @keyframes flicking {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ServicesWrapper = styled.div`
  ${Wrapper} {
    background: url(${require("../../images/service-img.png")}) right bottom /
      200px no-repeat;
    padding: ${SectionPadding};
    @media screen and (max-width: ${MobileWidth}) {
      background-size: 120px;
      padding: 50px 20px;
    }
  }

  .services-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    @media screen and (max-width: ${MobileWidth}) {
      margin-top: 10px;
    }

    .service-item {
      flex: 0 1 calc(25% - 20px);
      margin: 10px;
      text-align: center;
      transform: scale(0);
      transition: all 400ms ${MaterialCubicBezier};
      @media screen and (max-width: ${MobileWidth}) {
        margin: 5px;
        flex-basis: calc(50% - 10px);
      }

      &.active {
        transform: scale(1);
      }

      img {
        height: 120px;
        margin-bottom: 10px;
      }

      p {
        line-height: 26px;
        @media screen and (max-width: ${MobileWidth}) {
          line-height: 20px;
        }
      }

      .title {
        color: ${PrimaryColor};
        font-family: "Fjalla One", "Open Sans", sans-serif;
        font-size: 1.2rem;
      }
    }
  }
`;

export const FaqsWrapper = styled.div`
  background-color: ${PrimaryColor};
  color: #fff;
  padding: ${SectionPadding};
  @media screen and (max-width: ${MobileWidth}) {
    padding: ${SectionPaddingMobile};
  }

  .faqs-container {
    margin-top: 50px;
    @media screen and (max-width: ${MobileWidth}) {
      margin-top: 10px;
    }
  }
`;

export const ClientsWrapper = styled.div`
  background-color: #efefef;
  padding: ${SectionPadding};
  overflow: hidden;
  @media screen and (max-width: ${MobileWidth}) {
    padding: ${SectionPaddingMobile};
  }

  .clients-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 30px;
    @media screen and (max-width: ${MobileWidth}) {
      justify-content: center;
    }

    img {
      opacity: 0;
      transform: scale(2);
      transition: all 400ms ${MaterialCubicBezier};
      &.active {
        opacity: 1;
        transform: scale(1);
      }

      @media screen and (max-width: ${MobileWidth}) {
        margin-bottom: 20px;
        max-width: 90%;
      }
    }
  }
`;

export const TeamsWrapper = styled.div`
  padding: ${SectionPadding};
  @media screen and (max-width: ${MobileWidth}) {
    padding: ${SectionPaddingMobile};
  }

  .teams-container {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 50px;
    @media screen and (max-width: ${MobileWidth}) {
      margin-top: 20px;
    }

    .team-member {
      color: #777;
      flex: 1 1 calc(100% / 3);
      text-align: center;
      @media screen and (max-width: ${MobileWidth}) {
        flex-basis: 50%;
        margin-bottom: 20px;
      }

      strong {
        color: #000;
        font-size: 1.1rem;
      }

      .img-wrapper {
        background-color: #c4c4c4;
        border-radius: 50%;
        height: 100px;
        width: 100px;
        margin: 0 auto 10px;
        overflow: hidden;

        &.active {
          animation: flip 800ms ${MaterialCubicBezier} forwards;
        }

        img {
          width: 100%;
        }
      }
    }
  }

  @keyframes flip {
    from {
      transform: rotateY(0);
    }
    to {
      transform: rotateY(900deg);
    }
  }
`;

export const EducationWrapper = styled.div`
  padding: ${SectionPadding};
  @media screen and (max-width: ${MobileWidth}) {
    padding: ${SectionPaddingMobile};
  }
  .edu-container {
    margin-top: 50px;
    display: flex;
    @media screen and (max-width: ${MobileWidth}) {
      margin-top: 20px;
      flex-direction: column;
    }
    p {
      background-color: #eee;
      padding: 20px;
      height: 100%;
      &:not(:last-child) {
        margin-right: 20px;
        @media screen and (max-width: ${MobileWidth}) {
          margin-right: 0;
          margin-bottom: 20px;
        }
      }
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          position: relative;
          padding-left: 20px;
          margin-top: 10px;
          &:before {
            content: '';
            position: absolute;
            background-color: ${PrimaryColor};
            width: 6px;
            height: 6px;
            border-radius: 50%;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
`;
